// hooks/usePersistedState.js
import { useState, useEffect } from 'react';

const usePersistedState = (key, defaultValue) => {
  const [state, setState] = useState(() => {
    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : defaultValue;
    } catch (error) {
      console.error(`Error reading localStorage key "${key}":`, error);
      return defaultValue;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(key, JSON.stringify(state));
    } catch (error) {
      console.error(`Error setting localStorage key "${key}":`, error);
    }
  }, [key, state]);

  return [state, setState];
};

export default usePersistedState;




// hooks/usePersistedState.js
// import { useState, useEffect } from 'react';

// const usePersistedState = (key, defaultValue) => {
//   const [state, setState] = useState(() => {
//     try {
//       const item = localStorage.getItem(key);
//       return item ? JSON.parse(item) : defaultValue;
//     } catch (error) {
//       console.error(`Error reading localStorage key "${key}":`, error);
//       return defaultValue;
//     }
//   });

//   useEffect(() => {
//     try {
//       const current = JSON.stringify(state);
//       const def = JSON.stringify(defaultValue);
//       if (current === def) {
//         // Remove key when state equals default to keep storage clean
//         localStorage.removeItem(key);
//       } else {
//         localStorage.setItem(key, current);
//       }
//     } catch (error) {
//       console.error(`Error setting localStorage key "${key}":`, error);
//     }
//   }, [key, state]);

//   return [state, setState];
// };

// export default usePersistedState;